module.exports = __webpack_public_path__ + "static/media/nemlig-logo.a4450da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/nemlig-logo.png
// module id = 894
// module chunks = 0